import { Injectable } from '@angular/core';
import {Offer} from '../../models/offer/offer.model';
import {OfferRecommendationType} from '../../consts/offer-recommendation-type.enum';
import {RestApiService} from '../../../shared/services/rest-api.service';
import {ApplicationStateService} from '../../../shared/services/application-state.service';
import {BusinessParamName} from '../../../shared/models/request-offer/request-offer.enum';
import {ConfigurationService} from './configuration/configuration.service';
import {MetricsService, RequestMetricName} from '../../../shared/services/metrics.service';
import {RequestMetricResult} from '../../../shared/components/models/metrics/request-metric-result.enum';

@Injectable({
  providedIn: 'root'
})
export class OfferRecommendationsApiService {

  private readonly CLASSNAME = 'OfferRecommendationsApiService';

  get url(): string {
    return this.configuration.uiConfig.offerRecommendationsEndpoint;
  }

  constructor(private metricsService: MetricsService,
              private configuration: ConfigurationService,
              private stateService: ApplicationStateService,
              private api: RestApiService) { }

  getRecommendations(): Promise<OfferRecommendation[]> {
    this.sendRequestMetric();
    return this.api.get(`${this.url}?calculationId=${this.stateService.getBusinessParameterValue(BusinessParamName.CALCULATION_ID)}`);
  }

  private sendRequestMetric(): void {
    let metricName = {
      className: this.CLASSNAME,
      methodName: 'getRecommendations'
    };

    this.metricsService.sendRequestMetric(<RequestMetricName>{
      ...metricName,
      type: RequestMetricResult.SEND
    }, {
      calculationId: this.stateService.getBusinessParameterValue(BusinessParamName.CALCULATION_ID)
    });
  }

}

export interface OfferRecommendation {
  recommendationType: OfferRecommendationType;
  offerId?: string;
  offer?: Offer;
}
